module.exports = __webpack_public_path__ + "static/media/ooyala-logo.971cfd9a.png";